module.exports = __webpack_public_path__ + "img/people.9a1ab227.svg";